type Op = {status:string; observacoes?:string|null|undefined; saldo_bancario_vincendo?:number|null|undefined; valor_em_aberto?:number|null|undefined};
export const margem = (o:Op) => o.observacoes?.includes('[CEDULA_GUARDA_CHUVA]') ?? false;
export const vigente = (o:Op) => !['quitada','cancelada'].includes(o.status) && !margem(o);
export const saldoExibido = (o:Op):number|null => !vigente(o) ? null : (o.saldo_bancario_vincendo ?? o.valor_em_aberto ?? null);
export function totalVigentes(ops:Op[]) {
 const rows=ops.filter(vigente);
 const informados=rows.filter(o=>o.saldo_bancario_vincendo!=null);
 return {
  total:informados.reduce((s,o)=>s+(o.saldo_bancario_vincendo??0),0),
  incompleto:rows.some(o=>o.saldo_bancario_vincendo==null),
  bancario:informados.length>0,
 };
}
